export default __webpack_public_path__ + "static/media/img-kahsh-labs-services.372513e2.png";